module.exports = __webpack_public_path__ + "a3b09ed6cd0e385d68266c9143919f5e.svg";